import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import MovieCard from "@/components/base/MovieCard";
import { movies } from "@/mocks/movies";
import { tvshows } from "@/mocks/tvshows";
import type { MediaItem } from "@/types/media";

const tabs = [
  { key: "movie", label: "热门电影" },
  { key: "tv", label: "热播剧集" },
] as const;

export default function HotMedia() {
  const [tab, setTab] = useState<"movie" | "tv">("movie");
  const list: MediaItem[] = tab === "movie" ? (movies as MediaItem[]).slice(0, 8) : (tvshows as MediaItem[]).slice(0, 8);

  return (
    <section className="container-page mt-12 md:mt-16">
      <SectionHeading
        icon="ri-fire-line"
        title="热门影视推荐"
        subtitle="根据热度与口碑精选，发现值得一看的影片与剧集"
        moreLink={tab === "movie" ? "/movies" : "/tvshows"}
      >
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`whitespace-nowrap rounded-full px-3 py-1 text-sm transition-colors ${
                tab === item.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </SectionHeading>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
        {list.map((item) => (
          <MovieCard key={item.id} item={item} kind={tab === "tv" ? "tv" : "movie"} />
        ))}
      </div>
    </section>
  );
}